import { BnAction } from '../../common/bn-action';
import { sharedStyles } from '../../styles/shared-styles';
import { css } from '../../utility/lit-entity';

class HoldButton extends BnAction {
  constructor() {
    super();
    this.actionname = 'hold-work-order';
    this.errortext = 'Failed to put work order on hold.';
    this.successtext = 'Work Order has been put on hold.';
    this.submittext = 'Hold';
    this.suppressheader = true;
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: inline-block;
      }
    `];
  }
}

window.customElements.define('hold-button', HoldButton);
